export default __webpack_public_path__ + "static/sherpa_logo_blue-0b8c6a5ab1644b47b68d768423fd6a7d.png";